export const getDocument = (store, documentName) => {
    if (!store) {
        return null;
    }
    const document = store.workspace.documents[documentName];
    if (!document) {
        return null;
    }
    return document;
};
